export class CRadioGroup extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
  }

  connectedCallback() {
    const name = this.getAttribute('name') || 'group';
    const isSelected = this.hasAttribute('selected');
    const isDisabled = this.hasAttribute('disabled');

    const options = Array.from(this.querySelectorAll('option'));

    let radiosHtml = options.map((opt, idx) => `
      <label class="radio-wrapper">
        <input 
            type="radio" name="${name}" 
            value="${opt.getAttribute('value')}" 
            id="${name}-${idx}"
            ${isSelected ? 'checked' : ''}
            ${isDisabled ? 'disabled' : ''}
        >
        <span class="custom-dot"></span>
        <span class="radio-label">${opt.textContent}</span>
      </label>
    `).join('');

    this.shadowRoot.innerHTML = `
      <style>
        :host {
          display: flex;
          flex-direction: column;
          gap: 0.5rem;
        }
        .radio-wrapper {
          display: flex;
          flex-direction: row;
          align-items: center;
          gap: 4px;
          cursor: pointer;
          color: var(--black);
          position: relative;
          opacity: ${isDisabled ? '.5' : '1'}
        }
        .radio-label{
            font-size: 15px
        }
        input[type="radio"] {
          appearance: none;
          width: 20px;
          height: 20px;
          border: 2px solid var(--tempora-primary-300);
          border-radius: 50%;
          background: var(--tempora-primary-200);
          cursor: pointer;
          position: relative;
          transition: all 0.3s ease;
        }
        input[type="radio"]:checked {
          background: var(--tempora-primary);
          border-color: var(--tempora-primary);
        }
        input[type="radio"]:not(:checked):hover {
            background: ${!isDisabled ? 'var(--tempora-primary-100)' : 'var(--tempora-primary-200)'};
            border-color: var(--tempora-primary-300);
        }
        .custom-dot {
          position: absolute;
          left: 9px;
          top: 7px;
          width: 12px;
          height: 12px;
          border-radius: 50%;
          background: white;
          transform: scale(0);
          transition: transform 0.2s ease;
          pointer-events: none;
        }
        input[type="radio"]:checked + .custom-dot {
          transform: scale(1);
        }
      </style>
      ${radiosHtml}
    `;
  }
}
customElements.define('c-radio-group', CRadioGroup);